class Slider {
	protected $root:JQuery;
	protected $slider:any;
	protected $dots:JQuery;

	constructor(e) {
		this.$root = $(e);
		this.$slider = this.$root.find('.slider');
		this.$dots = this.$root.find('ul.dots a');
	}

	init() {
		this.$slider.slick({
			arrows: false, dots: false,
			infinite: true, autoplay: true,
			speed: 500, autoplaySpeed: 4500
		}).on('afterChange', (e, slick, index) => {
			this.$dots.removeClass('ON').eq(index).addClass('ON');
		}).slick('slickGoTo', 0, false);
		this.$dots.each((i, e) => {
			$(e).data('index', i);
		}).click(e => {
			let index = $(e.target).data('index');
			this.$slider.slick('slickGoTo', index);
		});
		return this;
	}
}

export default Slider;


/** WEBPACK FOOTER **
 ** ./src/scripts/modules/Slider.ts
 **/